import React from "react";
import { usePathname, useSearchParams } from "next/navigation";
import classes from "./Loader.module.scss";

export function Loader() {
  const [loading, setLoading] = React.useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  React.useEffect(() => {
    // When the route changes, set loading to true
    setLoading(true);

    // Set a small timeout to simulate the loading effect
    // since App Router doesn't have built-in events
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [pathname, searchParams]);

  return (
    <div className={`${classes.loaderBar} ${loading ? classes.loading : ""}`} />
  );
}
